<template>
	<div id="login">
		<div class="title">
			<span>欢迎来到</span>
			<span>宝葫芦AI心理云平台</span>
		</div>
		<div class="center">
			<img  class="icon01" src="@/assets/icon-01.png" />
			<div style="flex: 1;">
				<img width="100%" height="100%" src="../assets/center.png" />
			</div>
			<div style="flex: 1;">
				<h4 style="text-align: center;font-weight: bold;font-size: 22px;color: #293147;">学生端登录</h4>
				<form>
					<div class="formItem">
						<label>
							<img style="transform: scale(1.2);" src="../assets/loginIocn-01.png" />
							学校代码
						</label>
						<input @keyup.enter="loginFun()" v-model="formData.customerCode" autocomplete="off" placeholder="请输入学校代码" />
					</div>
					<div class="formItem">
						<label>
							<img src="../assets/loginIocn-02.png" />
							账号
						</label>
						<input @keyup.enter="loginFun()" v-model="formData.username" autocomplete="off" placeholder="请输入账号" />
					</div>
					<div class="formItem">
						<label>
							<img src="../assets/loginIocn-03.png" />
							密码
						</label>
						<input @keyup.enter="loginFun()" v-model="formData.password" autocomplete="new-password" type="password" placeholder="请输入密码" />
					</div>
					<div class="formItem" style="padding: 0;height: 43px;">
						<label style="margin-left: 10px;">
							<img src="../assets/loginIocn-04.png" />
							验证码
						</label>
						<input @keyup.enter="loginFun()" v-model="formData.code" autocomplete="off" placeholder="请输入验证码" style="width: 100px;" />
						<img @click="getTzm()" style="flex: 1;width: 100px;" :src="yzmImg" />
					</div>
				</form>
				<div style="text-align: center;">
					<el-button style="background: #59E4B5;border:1px solid #59E4B5;width: 386px;font-size: 16px;" type="primary" @click="loginFun()" :loading="loading">登 录</el-button>
				</div>
				<!-- <div @click="loginFun()"  class="btn">登录</div> -->
			</div>
		</div>
		<div class="footer">
			<span @click="showFwAntk(true)" class="fw">服务与条款</span>
			<span style="margin: 0 20px;">Copyright © 2009-2025 宝葫芦集团 版权所有</span>
			<span>皖ICP备14018840号-1</span>
		</div>
		<div class="urlBtnBox">
			<span @click="go(1)" v-if="education.show">教育局端</span>
			<span  @click="go(2)" v-if="school.show">学校端</span>
		</div>
		<el-dialog
		  title="服务与条款"
		  :visible.sync="isShowFw"
		  :close-on-click-modal= "false"
		  :close-on-press-escape= "false"
		  :show-close= "false"
		  width="60%"
		  >
		  <div v-html="content"></div>
		  <span slot="footer" class="dialog-footer" style="text-align: center!important;">
		    <el-button @click="showFwAntk(false)">关闭</el-button>
		  </span>
		</el-dialog>

	</div>
</template>

<script>
	import {login, captchaImage,getInfo} from '@/api/login.js'
	import {setToken,removeToken } from '@/utils/auth.js'
  import {getScreenInfo} from "@/api/user";
	export default {
	  name:'login',
	  data() {
	    return {
			loading:false,
			isShowFw:false,
			school:window.school,
			education:window.education,
      baseUrl:window.baseUrl,
			yzmImg:'',
			formData:{
				customerCode:'',
				username:'',
				password:'',
				code:'',
				uuid:'',
			},
			content:window.content,
		}
	  },
	  created() {

	  },
	  mounted() {
		  removeToken();
		  localStorage.removeItem('userInfo')
		  this.$store.state.userInfo = ''
		  this.getTzm();
		  this.screenInfo();
	  },
	  methods:{
      screenInfo(){
        getScreenInfo().then((res)=>{
          console.log('screenInfo')
          if(res.code == 200){
            var _loginLogo = res.data.loginLogo;
            if(_loginLogo!=null){
              this.$store.state.logoInfo = _loginLogo;
              localStorage.setItem('logoInfo',_loginLogo)
              this.customerLogo = this.baseH + _loginLogo;
              var link = document.querySelector('link[rel*="icon"]');
              link.href=this.baseUrl+_loginLogo;
            }
          }
        });
      },
		 go(type){
			 let url = type == 1 ? this.education.url : this.school.url;
			 window.open(url)
		 },
		 getTzm(){
			 captchaImage().then((res)=>{
				 if(res.code == 200){
					 this.yzmImg = 'data:image/*;base64,'+ res.img;
					 this.formData.uuid = res.uuid
				 }
			 })
		 },
		 loginFun(){
			 let data = this.formData;
			 if(data.customerCode == ''){
				 this.$message.error('请输入学校代码！');
				 return false;
			 }
			 if(data.username == ''){
				 this.$message.error('请输入账号！');
				 return false;
			 }
			 if(data.password == ''){
				 this.$message.error('请输入密码！');
				 return false;
			 }
			 if(data.code == ''){
				 this.$message.error('请输入验证码！');
				 return false;
			 }
			 this.loading = true;
			 data.username = md5(data.username)
			 data.password = md5(data.password)
			 login(data).then((res)=>{
				 this.loading = false;
				 console.log(res)
				 if(res.code == 200){
					 setToken(res.data);
					 getInfo().then((res)=>{
						 if(res.code == 200){
							 this.$store.state.userInfo = JSON.stringify(res.data);
							 localStorage.setItem('userInfo',JSON.stringify(res.data));
							 localStorage.setItem('loginName',res.data.loginName);
							 localStorage.setItem('loginLogo',res.data.loginLogo);
						 }
					 })
					 this.$router.push({
						 path:'/index'
					 })
				 }else{
					 data.username = '';
					 data.password = '';
					 data.code = '';
					 this.getTzm();
				 }
			 })
		 },
		 showFwAntk(isShow){
			 this.isShowFw = isShow;
		 }
	  }
	}
</script>
<style>
			.el-dialog__footer{
				text-align: center;
			}
</style>
<style scoped>
	.urlBtnBox{
		position: fixed;
		right:0;
		bottom: 50px;
		display: flex;
		flex-direction: column;
	}
	.urlBtnBox span{
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		box-shadow: 0 1px 8px rgba(0,0,0,0.2);
	}
	.urlBtnBox span:first-child{
		width: 124px;
		height: 50px;
		background-color: #CAE8F8;
		color: #033333;
		border-radius: 50px 0px 0 50px;

	}
	.urlBtnBox span:last-child{
		width: 124px;
		height: 50px;
		background-color: #F0E7D2;
		color: #E0880B;
		border-radius: 50px 0px 0 50px;
		margin-top: 20px;
	}
	#login{
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		height: 100vh;
	}
	.footer{
		position: fixed;
		bottom: 10px;
		left: 0;
		right: 0;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 14px;
		color: #96A0A0;
	}
	.fw{
		text-decoration: underline;
		cursor: pointer;
	}
	.fw:hover{
		color: #59E4B5;
	}
	.center{
		width: 900px;
		height: 460px;
		box-shadow: 2px 3px 10px rgba(0,0,0,0.2);
		background-color: #fff;
		border-radius: 20px;
		position: relative;
		margin-top: 40px;
		margin-bottom: -40px;
		display: flex;
	}
	.icon01{
		width: 140px;
		position: absolute;
		left: -60px;
		top: -50px;
	}
	.title{
		display: flex;
		align-items: center;
	}
	.title span:first-child{
		font-size: 22px;
		color: #525D70;
		margin-right: 20px;
	}
	.title span:last-child{
		color:#293147;
		font-size: 34px;
	}

	form{
		margin: 30px;
	}
	.formItem{
		border: 1px solid #EAEAEA;
		display: flex;
		align-items: center;
		border-radius: 5px;
		padding: 10px;
		margin-bottom: 20px;
	}
	.formItem label{
		width: 100px;
		display: flex;
		align-items: center;
		border-right: 1px solid #EAEAEA;
		margin-right: 20px;
		padding: 0 10px;
	}
	.formItem label img{
		width: 20px;
		margin-right: 10px;
	}
	.formItem input{
		flex: 1;
		border: none;
		font-size: 16px;
		outline: none;
	}
	.btn{
		background: #59E4B5;
		height: 50px;
		margin: 30px;
		border-radius: 10px;
		display: flex;
		align-items: center;
		justify-content: center;
		color: #fff;
		font-weight: bold;
		font-size: 20px;
		cursor: pointer;
	}
	.btn:active{
		opacity: 0.8;
	}
</style>
